import browserUpdate from 'browser-update';

browserUpdate({
    required: {
        e: -3, // Internet Explorer: the last 2 versions
        f: -3, // Firefox: the last 3 versions
        o: -3, // Opera: the last 3 versions
        s: -3, // Safari: the last 2 versions
        c: -3, // Chrome: the last 3 versions
        y: -3,
        v: -3,
        uc: -3,
        samsung: -3
    },
    insecure: false,
    unsupported: false,
    test: false,
    reminder: 0,
    reminderClosed: 168,
    style: 'top',
    text: "Our application does not support {brow_name} which is too old. You may experience issues. Please update or use a different browser. <a{ignore_but}>X</a>"
});
